export const IE = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_15691)">
      <g clipPath="url(#clip1_1073_15691)">
      <rect x="64" y="96" width="96" height="32" transform="rotate(-90 64 96)" fill="#EF8244"/>
      <rect x="32" y="96" width="96" height="32" transform="rotate(-90 32 96)" fill="white"/>
      <rect y="96" width="96" height="32" transform="rotate(-90 0 96)" fill="#00C17B"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_15691">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_15691">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
